import { type CSSProperties } from 'react'

export const isActive = (section, currentSection) => section.id === currentSection

export interface AlignmentClasses {
  text: string
  justify: string
}

const ALIGNMENT_CLASSES: Record<string, AlignmentClasses> = {
  left: { text: 'text-left', justify: 'justify-start' },
  start: { text: 'text-left', justify: 'justify-start' },
  justify: { text: 'text-justify', justify: 'justify-start' },
  center: { text: 'text-center', justify: 'justify-center' },
  right: { text: 'text-right', justify: 'justify-end' },
  end: { text: 'text-right', justify: 'justify-end' },
}

export const getAlignmentClass = (style?: CSSProperties): AlignmentClasses | undefined =>
  style?.textAlign ? ALIGNMENT_CLASSES[String(style.textAlign)] : undefined
